import { TextField } from "@base/ui/TextField";
import { useTranslation } from "react-i18next";
import type { ApplyFormInstance } from "../model/useApplyForm";

type Props = {
  form: ApplyFormInstance;
};

export const CompanyInfoFields = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <form.Field name="companyName">
        {(field) => (
          <TextField required>
            <TextField.Label>{t("apply.company.label")}</TextField.Label>
            <TextField.Input
              value={field.state.value}
              onChange={(e) => {
                const filtered = e.target.value.replace(/[^\u0020-\u007E]/g, "").slice(0, 50);
                field.handleChange(filtered);
              }}
              onBlur={field.handleBlur}
              placeholder={t("apply.company.placeholder")}
            />
          </TextField>
        )}
      </form.Field>

      <div className="flex flex-col md:flex-row gap-8 md:gap-4">
        <form.Field name="firstName">
          {(field) => (
            <TextField required className="md:flex-1" disabled>
              <TextField.Label>{t("apply.representative.firstName.label")}</TextField.Label>
              <TextField.Input value={field.state.value} disabled />
            </TextField>
          )}
        </form.Field>

        <form.Field name="lastName">
          {(field) => (
            <TextField required className="md:flex-1" disabled>
              <TextField.Label>{t("apply.representative.lastName.label")}</TextField.Label>
              <TextField.Input value={field.state.value} disabled />
            </TextField>
          )}
        </form.Field>
      </div>
    </>
  );
};
